import { IconContent } from '@icons';

export const checkmarkCircleFilled: IconContent = {
    sm: '<path d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-7.875 3.395 5.041-5.041-.707-.708L7.125 9.98 4.854 7.71l-.708.707 2.979 2.979Z" />',
};
